<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import TaccSelect from 'dashboard/components/widgets/conversation/tacc/TaccSelect.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  companies: {
    type: Array,
    default: () => [],
  },
  agents: {
    type: Array,
    default: () => [],
  },
  loadingAgents: {
    type: Boolean,
    default: false,
  },
  statusOptions: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:filters']);

const updateFilter = (key, value) => {
  emit('update:filters', { ...props.filters, [key]: value });
};

const resetFilters = () => {
  emit('update:filters', {
    search: '',
    company_name: '',
    agent_id: '',
    status: props.type === 'tasks' ? '' : 'scheduled',
  });
};
</script>

<template>
  <div class="flex w-full flex-col gap-3">
    <div class="flex flex-col gap-2 lg:flex-row lg:items-center">
      <Input
        :model-value="filters.search"
        type="search"
        :placeholder="type === 'tasks' ? 'Search tasks...' : 'Search reminders...'"
        :custom-input-class="[
          'h-10 [&:not(.focus)]:!border-n-weak bg-n-alpha-1 dark:bg-n-solid-1 ltr:!pl-9 rtl:!pr-9',
        ]"
        class="w-full lg:w-80"
        @input="updateFilter('search', $event.target.value)"
      >
        <template #prefix>
          <Icon
            icon="i-lucide-search"
            class="absolute top-1/2 size-4 -translate-y-1/2 text-n-slate-11 ltr:left-3 rtl:right-3"
          />
        </template>
      </Input>

      <div class="grid min-w-0 flex-1 grid-cols-1 gap-2 sm:grid-cols-3">
        <TaccSelect
          :model-value="filters.company_name"
          :options="companies"
          placeholder="All companies"
          @update:model-value="updateFilter('company_name', $event)"
        />

        <TaccSelect
          :model-value="filters.agent_id"
          :options="agents"
          placeholder="All agents"
          :loading="loadingAgents"
          @update:model-value="updateFilter('agent_id', $event)"
        />

        <TaccSelect
          :model-value="filters.status"
          :options="statusOptions"
          @update:model-value="updateFilter('status', $event)"
        />
      </div>

      <Button
        color="slate"
        size="sm"
        variant="ghost"
        label="Reset"
        class="h-10 shrink-0"
        @click="resetFilters"
      />
    </div>
  </div>
</template>
